<div class="jobs-eures-search" *ngIf="euresJobsControl" [formGroup]="euresJobsForm">
  <mat-icon
    *ngIf="!modalOpen"
    class="jobs-eures-search__icon"
    matPrefix
    [svgIcon]="field.icon"
    role="presentation"
  ></mat-icon>
  <input
    formControlName="metier"
    type="text"
    class="jobs-eures-search__input"
    matInput
    [matAutocomplete]="auto"
    [placeholder]="field.placeholder"
    [attr.aria-label]="field.ariaLabel"
  />
  <button
    type="button"
    *ngIf="!!euresJobsControl.value"
    class="btn-clean delete-btn jobs-eures-search__clear-btn jobs-eures-search__icon--delete"
    [attr.aria-label]="'Suppression du filtre ' + field.ariaLabel"
    (click)="clearValue($event)"
    matSuffix
  >
    <mat-icon svgIcon="cross" role="presentation"></mat-icon>
  </button>

  <mat-autocomplete
    autoActiveFirstOption
    #auto="matAutocomplete"
    class="dropdown-panel dropdown-panel--eures"
    [displayWith]="displayEuresJobName"
    (optionSelected)="selectValue($event)"
    (closed)="onClose()"
  >
    <mat-option *ngFor="let euresJob of euresJobs$ | async; trackBy: trackByJobName" [value]="euresJob"
      >{{ euresJob.name }}
    </mat-option>
  </mat-autocomplete>
</div>
